import axios from 'axios'
import { getSessionToken } from '../session'

const PHENOMENA_STATISTICS_API_URL = process.env.REACT_APP_PHENOMENA_STATISTICS_API_URL

const GET = 'GET'
const POST = 'POST'
const DELETE = 'DELETE'
const PATCH = 'PATCH'

async function httpRequest(method, path, payload = null) {
    return axios({
        method,
        url: `${PHENOMENA_STATISTICS_API_URL}/${path}`,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionToken()}`
        },
        withCredentials: true,
        data: payload || null
    })
}

const phenomenaStatisticsApi = {
  getPhenomenaStatistics: async (uuids) => {
    return httpRequest(GET, `?uuids=${uuids}`)
  }
}

export default phenomenaStatisticsApi